module.exports = __webpack_public_path__ + "static/media/Milex-Shaatz-Pessary-Instructions-for-Use@2x.3b0b477b.jpg";